export default function copyObject(source) {
    if (source === null || source === undefined)
        return {};

    return JSON.parse(JSON.stringify(source));
}